import { Config } from '@leverege/plugin';
import I18N from '@leverege/i18n';
const {
  t,
  tf,
  tfArray
} = I18N.ns('molten.screens.account.IntercomChat');
export default {
  id: 'molten.link.mobile.IntercomChat',
  matches: {
    use: 'userBar',
    client: 'Main'
  },
  name: tf('name'),
  layout: Config.get('Intercom', 'chatLinkLayout', {
    group: ['help'],
    groupIcons: [Config.get('Main', 'helpIcon', 'https://molten-ui-assets.storage.googleapis.com/help.svg')],
    groupNames: tfArray('groupNames'),
    sort: '_a.a'
  }),
  sort: '_a',
  handles: context => Config.get('Intercom', 'appId') != null && context.mobile,
  appearance: () => {
    return Config.get('Intercom', 'chatLinkAppearance', {
      name: t('name')
    });
  },
  perform: () => {
    window?.Intercom('show');
  }
};